module.exports = __webpack_public_path__ + "static/media/hanakawado-asakusa-1.b05709de.jpg";